

















import {ref, reactive, computed, defineComponent, PropType} from '@vue/composition-api'
import {AnyParam, isAnimatedParam} from '@/params'

export default defineComponent({
  name: 'ParamAutokeyIcon',
  props: {
    param: {
      type: Object as PropType<AnyParam>,
      required: true
    }
  },
  setup(props, context) {
    const animatable = computed(() => {
      return isAnimatedParam(props.param)
    })

    const isAnimated = computed(() => {
      return props.param.isAnimated()
    })

    const autokey = computed(() => {
      if (!(isAnimatedParam(props.param)))
        return false
      return props.param.autokey
    })

    // status for tooltip
    const animationStatus = computed(() => {
      if (isAnimated.value && autokey.value)
        return "Animated param; click to turn off autokey"
      if (!isAnimated.value && autokey.value)
        return "Turn off autokey<br>(don't auto-create new keyframes on param change)"
      if (isAnimated.value && !autokey.value)
        return "Animated param; click to turn on autokey"
      else // (!this.isAnimated && !this.autokey)
        return "Turn on autokey<br>(Auto-create new keyframes on param change)"
    })

    const toggleAutokey = () => {
      context.emit('toggleAutokey')
    }

    return {animatable, isAnimated, autokey, toggleAutokey, animationStatus}
  }
})
